import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientMypageListItemSkeleton } from '@/feature/hotline/client/mypage/component/HotlineClientMypageList/HotlineClientMypageListItem/HotlineClientMypageListItemSkeleton';
import { hotlineClientMypageListStyle } from '@/feature/hotline/client/mypage/component/HotlineClientMypageList/style';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
/**
 * ホットライン マイページで使用する一覧コンポーネント スケルトン
 */
export const HotlineClientMypageListSkeleton = (props) => {
    const { className = '' } = props;
    const style = hotlineClientMypageListStyle();
    const dummies = useArrayWithIndex(4);
    return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: dummies.map(({ index }) => (_jsx(HotlineClientMypageListItemSkeleton, {}, index))) })));
};
